<template>
 <div>
    <div class="chartAndTools">
      <div class="title">
        <h3>Templates</h3>
      </div>
        </div>
          <div v-if="Msgtemplates.length>0" id="table-scroll">
           <table class="table">
            <tbody>
            <tr v-for="templ in Msgtemplates" :key="templ.id" style="cursor:pointer;">
                <td @click="$emit('sel-template',templ.id)">
                    <span class="templateHeader">{{templ.template_name}} </span><br>
                   <span class="templateSubHeader">{{templ.template_message}}</span><br>
                </td>
                 <td>
            <p-button     
            @click="EditTemplate(templ)"      
            type="success"
            size="sm"
           class="editButtonStyle"
            icon
          >
            <i class="fa fa-edit" title="Edit"></i>
          </p-button>
                </td>
                <td>
            <p-button     
            @click="$emit('delete-template',templ.id)"      
            type="danger"
            size="sm"
            class="deleteButtonStyle"
            icon
          >
            <i class="fa fa-times" title="Delete"></i>
          </p-button>
                </td>
            </tr>
            </tbody>
          </table>
           <i class="fa fa-plus-circle mr-2 addButtonStyle" title="Create template" aria-hidden="true" @click="OpenAddTemplateModal()"><span class="spanText mb-2">Template</span></i>
          </div>
          <div v-else>
            <span class="noRecordStyle">{{noRecordMessage}}</span><br>
             <i class="fa fa-plus-circle mr-2 addButtonStyle" title="Create template" aria-hidden="true" @click="OpenAddTemplateModal()"></i><span class="spanText mb-2">Template</span>
          </div>
       <el-dialog
        :visible.sync="templateModal"
        :center='true'
        :append-to-body="true"
        width="25%">
      <AddUpdateMessageTemplate
      @refresh-list="refreshTempList"
      :title="title"
      :message="message"
      :id="templateId"
      >
      </AddUpdateMessageTemplate>
        </el-dialog>
      </div>
</template>
<script>
import Button from '../../../UIComponents/Button.vue'
import AddUpdateMessageTemplate from "@/components/Dashboard/Views/MessagingTemplate/AddUpdateMessageTemplates.vue"
export default {
  components: { 
    Button,
    AddUpdateMessageTemplate
    },
    props:{
        Msgtemplates:{},
        noRecordMessage:'',        
        refreshList:''
    },
    data(){
      return{
       refreshTemplateListData:'',
       templateModal:false,
        title:'',
        message:'',
        templateId:0
      }
    },
    methods:{
      async OpenAddTemplateModal(){
        this.title='';
        this.message='';
        this.templateId=0;
        this.templateModal=true;
      },

      async refreshTempList(messg)
      {
        this.refreshTemplateListData=messg;
         this.templateModal=false;
        this.$emit('refreshTempList',this.refreshTemplateListData);
      },
      async EditTemplate(template){
        this.title=template.template_name;
        this.message=template.template_message;
        this.templateId=template.id;
         this.templateModal=true;
      }
    }

}
</script>
<style scoped>
.title {
  text-align: center;
}
.chartAndTools {
  border-width: 10px;
  border-radius: 10px;
  border-color: lightsteelblue;
}
.chart {
  height: 328px;
  width: 558px;
}
#table-scroll {
  height:350px;
  overflow:auto;  
  margin-top:0px;
}
.noRecordStyle{
  font-size: 15px;
  padding-left: 128px;
  color: red;
}
.templateHeader{
    font-size: 14px;
    font-weight: 600;
}
.templateSubHeader{
     font-size: 12px;
}
.addButtonStyle{
    color: #409EFF !important;
    cursor: pointer;
   font-size: 22px !important
}
.deleteButtonStyle{
  position: relative;
    left: 30%
}
.editButtonStyle{
  position: relative;
   left: 90%
}
.spanText{
  font-size: 15px;
  color: #409EFF !important;
  position: relative;
  bottom: 3px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  margin-left: 6px
}
</style>